import { DispatchType } from '../../../@types/redux-types'
import { loadCountries as loadCountriesApi, loadRegions } from '../../../api/geoManualHierarchy/geoManualHierarchyApi'
import { showMessage } from '../../reducers/message/messageFeature'
import { DropdownOptionSelection } from '../../../@types/types'
import {
  loadCountriesSuccess,
  loadInternationalRegionsSuccess,
  resetAddressFeature,
} from '../../reducers/address/addressFeature'

export const loadCountries = () => async (dispatch: DispatchType) => {
  try {
    const countries = await loadCountriesApi()
    dispatch(loadCountriesSuccess({ countries: countries }))
  } catch (error) {
    dispatch(showMessage({ message: 'unknown' }))
  }
}

export const doLoadRegions = (country: DropdownOptionSelection) => async (dispatch: DispatchType) => {
  if (country.value !== null && country.value !== '0' && country.value !== undefined) {
    const regions = await loadRegions(country.value)
    dispatch(loadInternationalRegionsSuccess({ regions: regions }))
  }
}

export const loadRegionsOfCountry = (country: DropdownOptionSelection) => async (dispatch: DispatchType) => {
  if (country.value) {
    try {
      await doLoadRegions(country)(dispatch)
    } catch (error) {
      dispatch(showMessage({ message: 'unknown' }))
    }
  }
}

export const doResetAddressFeature = (isNational: boolean) => (dispatch: DispatchType) => {
  dispatch(resetAddressFeature({ isNational: isNational }))
}
